import { render, staticRenderFns } from "./BulkActionTasksTable.vue?vue&type=template&id=700ad425&scoped=true&"
import script from "./BulkActionTasksTable.vue?vue&type=script&lang=ts&"
export * from "./BulkActionTasksTable.vue?vue&type=script&lang=ts&"
import style0 from "./BulkActionTasksTable.vue?vue&type=style&index=0&id=700ad425&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700ad425",
  null
  
)

export default component.exports